import i18next from 'i18next'

import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import { RightArrow } from './commons'

// i18next.exists() resolves the key without going through the missingKey
// handler/telemetry, so URLs, UUIDs and objects that have no real
// campaign.logs.values.* key skip translation instead of spamming warnings.
const translateIfExists = (value: DefaultChangeProps['prevValue']) => {
  const key = `rm:campaign.logs.values.${value}`
  return i18next.exists(key) ? i18next.t(key) : value
}

const GenericContent = ({ prevValue, newValue }: DefaultChangeProps) => {
  const { t } = useAPPTranslation()

  const values = {
    prevValue:
      prevValue != null && prevValue !== ''
        ? translateIfExists(prevValue)
        : prevValue,
    newValue:
      newValue != null && newValue !== ''
        ? translateIfExists(newValue)
        : newValue
  }

  return (
    <>
      <span className="prevValue">
        {['', null].includes(prevValue) ? (
          <i>{t('rm:campaign.logs.empty_value')}</i>
        ) : (
          JSON.stringify(values.prevValue)
        )}
      </span>
      <RightArrow />
      <span className="newValue">
        {['', null].includes(newValue) ? (
          <i>{t('rm:campaign.logs.empty_value')}</i>
        ) : (
          JSON.stringify(values.newValue)
        )}
      </span>
    </>
  )
}

export default GenericContent
